const badgeStyles = (tokens) => ({
    variants: {
        'dark-grey': {
            backgroundColor: tokens.CanvasDarkGrey,
            px: 2,
            py: 0,
            textColor: tokens.TextWhite100,
            borderRadius: tokens.BorderRadius02,
            minW: tokens.Spacing08,
            textAlign: 'center',
        },
    },
});
export default badgeStyles;
